import React from 'react'
import {
    Flex,
    Button,
    Text,
    Image,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {PlusIcon} from '../../../components/icons'
import {InformativeLabelGroup} from '../../../components/informative-label'

const FreeItemPromoBanner = ({onOpen, promo, setSelectedPromotion, selectedFreeItems}) => {
    const styles = useMultiStyleConfig('FreeItemPromo')
    const allowedItems = promo?.maxBonusItems || 0
    const selectedCount = (selectedFreeItems?.items || []).reduce(
        (sum, item) => sum + (item.quantity || 1),
        0,
    )
    const Image404 = 'https://dam.delonghi.com/902x902/assets/379675'

    const handleOpenPromoDrawer = () => {
        setSelectedPromotion({...promo})
        onOpen()
    }

    const PromoBannerButton = (manyItems) => {
        return (
            <Button
                onClick={() => handleOpenPromoDrawer()}
                variant="outline-not-rounded"
                size="small"
                leftIcon={<PlusIcon {...styles?.promoBanner?.buttonIcon} />}
            >
                {manyItems ? (
                    <Text {...styles?.promoBanner?.bannerButton}>
                        <FormattedMessage
                            id="cart.free_item_promo.banner_button_plural"
                            defaultMessage="Add them"
                        />
                    </Text>
                ) : (
                    <Text {...styles?.promoBanner?.bannerButton}>
                        <FormattedMessage
                            id="cart.free_item_promo.banner_button"
                            defaultMessage="Add it"
                        />
                    </Text>
                )}
            </Button>
        )
    }

    PromoBannerButton.propTypes = {
        manyItems: PropTypes.bool,
    }

    const isManyItemsInitial =
        allowedItems > 1 && (selectedCount === 0 || selectedFreeItems?.items === undefined)
    const isManyItemsPartial = allowedItems > 1 && selectedCount > 0 && selectedCount < allowedItems

    const renderMessage = () => {
        if (isManyItemsInitial) {
            return (
                <FormattedMessage
                    id="cart.free_item_promo.banner_message_plural"
                    defaultMessage="You got {count} free products!"
                    values={{count: allowedItems}}
                />
            )
        } else if (isManyItemsPartial) {
            return allowedItems - selectedCount === 1 ? (
                <FormattedMessage
                    id="cart.free_item.promo.banner_message_plural_intermediate"
                    defaultMessage="You can add another free product!"
                />
            ) : (
                <FormattedMessage
                    id="cart.free_item.promo.banner_message_plural_intermediate_count"
                    defaultMessage="You can add {count} more free products!"
                    values={{count: allowedItems - selectedCount}}
                />
            )
        } else {
            return (
                <FormattedMessage
                    id="cart.free_item_promo.banner_message"
                    defaultMessage="You got a free product!"
                />
            )
        }
    }

    const FreeGiftBannerContent = () => {
        return (
            <Flex {...styles?.promoBanner?.messageContainer}>
                <InformativeLabelGroup isFreeGift={true} />

                <Flex {...styles?.promoBanner?.bannerTextContainer}>
                    <Text {...styles?.promoBanner?.bannerTitle}>
                        <FormattedMessage
                            id="cart.free_item_promo.banner_title"
                            defaultMessage="Title for gift on the total order"
                        />
                    </Text>
                    <Text {...styles?.promoBanner?.bannerText}>{renderMessage()}</Text>
                </Flex>

                <PromoBannerButton manyItems={isManyItemsInitial} />
            </Flex>
        )
    }

    let content = null

    content =
        selectedCount >= allowedItems ? (
            <></>
        ) : (
            <Flex {...styles?.promoBanner?.outerContainer}>
                <Image src={Image404} alt={promo?.name} {...styles?.promoBanner?.image} />

                <FreeGiftBannerContent />
            </Flex>
        )
    return content
}

export default FreeItemPromoBanner

FreeItemPromoBanner.propTypes = {
    onOpen: PropTypes.func,
    allowedItems: PropTypes.number,
    promo: PropTypes.object,
    setSelectedPromotion: PropTypes.func,
    selectedFreeItems: PropTypes.object,
}
